<template>
    <div class="card">
        <div class="card-block">
            <div class="row">
                <div class="col-sm-12 col-md-2">
                    <label>{{ this.$i18n.QUERY_FILTERS }}</label>
                    <a
                        class="ml-1"
                        target="_blank"
                        :href="this.manualUrl"
                    >
                        <Help-circle-outline id="query-filters-info" :size="15" />

                        <b-tooltip container="null" target="query-filters-info" triggers="hover">
                            {{ this.$i18n.QUERY_FILTERS_INFO }}
                        </b-tooltip>
                    </a>
                </div>

                <div v-if="totalClauseCount === 0" class="col-sm-12 col-md-2">
                    <label v-on:click="toggleState" class="blue-button add-filters-label ml-1" id="add-query-button">
                        {{ this.$i18n.ADD_FILTERS }}
                    </label>
                </div>

                <div v-else class="col-10">
                    <div class="row">
                        <div class="col-10">
                            <label>{{ totalClauseCount }} {{ this.$i18n.FILTERS_SELECTED }}&nbsp;</label>
                            <label v-on:click="toggleState" class="blue-button add-filters-label ml-1">
                                {{ this.$i18n.EDIT }}
                            </label>
                        </div>
                        <div class="col-2">
                            <a href="#" v-on:click="removeAllFilters" class="red-button">
                                <close-circle />
                                {{ this.$i18n.REMOVE_ALL_FILTERS }}
                            </a>
                        </div>
                    </div>
                </div>

                <div :class="[mode === 'displayQueries' ? 'hiddenQueryFilters' : 'shownQueryFilters']">
                    <div class="col-12" id="accordion-container">
                        <div id="accordion">
                            <patientsSubQuery ref="patientsSubQuery" class="subQueryCategory px-0 py-0 mt-0" />
                            <caseSubQuery :module="module" ref="caseSubQuery" class="subQueryCategory px-0 py-0 mt-0" />
                            <mrFiltersSubQuery
                                ref="mrAttributesSubQuery"
                                class="subQueryCategory px-0 py-0 mt-0"
                                queryCategory="MrAttributes"
                                :name="this.$i18n.MRS"
                                :module="module"
                            />
                        </div>
                        <applyOrCancelFooter
                            class="buttonToolbar"
                            ref="footer"
                            applyButtonName="Apply"
                            cancelButtonName="Cancel"
                            v-on:cancelSession="cancelCurrentSession"
                            v-on:collapse="collapse"
                            :module="module"
                            :isNationalDataNeeded="isNationalDataNeeded"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import patientsSubQuery from "./patients.vue";
import caseSubQuery from "./cases.vue";
import mrFiltersSubQuery from "./mrfilters.vue";
import applyOrCancelFooter from "./apply-cancel-footer.vue";
import CloseCircle from "vue-material-design-icons/CloseCircle.vue";

import { BTooltip } from "bootstrap-vue";
import HelpCircleOutline from "vue-material-design-icons/HelpCircleOutline";

export default {
    data() {
        return {
            manualUrl: process.env.VUE_APP_MANUAL_URL,
            mode: "displayQueries",
            queryApplied: false,
            totalClauseCount: 0,
        };
    },
    props: {
        module: String,
        isNationalDataNeeded: { type: Boolean, default: true }
    },
    components: {
        patientsSubQuery: patientsSubQuery,
        caseSubQuery: caseSubQuery,
        applyOrCancelFooter: applyOrCancelFooter,
        mrFiltersSubQuery: mrFiltersSubQuery,
        CloseCircle,
        BTooltip,
        HelpCircleOutline,
    },
    methods: {
        ...mapActions(["cleanFilters"]),
        toggleState: function () {
            if (this.mode === "editQueries") {
                this.mode = "displayQueries";
            } else {
                this.mode = "editQueries";
            }
        },
        cancelCurrentSession: function () {
            this.mode = "displayQueries";
        },
        collapse: function () {
            this.mode = "displayQueries";
            this.queryApplied = true;

            this.totalClauseCount =
                this.$refs.patientsSubQuery.clauseCount +
                this.$refs.caseSubQuery.clauseCount +
                this.$refs.mrAttributesSubQuery.clauseCount;
        },
        removeAllFilters: function () {
            this.cleanFilters();
            this.$refs.patientsSubQuery.reboot();
            this.$refs.caseSubQuery.reboot();
            this.$refs.mrAttributesSubQuery.reboot();
            this.mode = "displayQueries";
            this.totalClauseCount = 0;
            this.$refs.footer.CleanData();
        },
    },
};
</script>

<style scoped>
.shownQueryFilters {
    display: contents;
}

.hiddenQueryFilters {
    display: none;
}

.buttonToolbar {
    float: right;
    padding: 1rem 0.5rem;
}

.add-filters-label {
    cursor: pointer;
}

>>> .flex-row {
    flex-wrap: wrap;
}

>>> .btn-link {
    color: #54667a !important;
    font-size: 1rem !important;
    font-weight: normal !important;
}

>>> .card-header {
    background-color: transparent !important;
    border-bottom: none !important;
}

>>> .card-body {
    padding-left: 30px;
}

>>> .blue-button {
    color: #009efb;
}

>>> .red-button {
    color: palevioletred;
}

>>> .red-button i {
    font-size: 20px;
}

>>> .blue-button i {
    font-size: 20px;
}

>>> h5 button {
    background: #f2f7f8;
    margin-top: 15px;
    margin-left: 12px;
    border-radius: 5px;
    box-shadow: none !important;
}

>>> h5 button:hover {
    background: #f2f7f8;
    text-decoration: none !important;
}

>>> h5 button:active {
    background: #f2f7f8;
}

>>> h5 button:focus {
    background: #f2f7f8;
}

>>> .dx-checkbox-container {
    display: flex;
}

#accordion-container {
    padding-left: 200px !important;
}

@media only screen and (max-width: 900px) {
    #accordion-container {
        padding-left: 0 !important;
    }
}
</style>
